// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2ig5W","buttons":"PendingPaymentAlert_buttons__1NpPU"};